import { ConsumoDto, ConsumoQueryParams } from "../typings";
import { useQuery } from "react-query";
import http from "infra/http";

export function useConsumo(query: ConsumoQueryParams) {
  return useQuery(
    [`/v1/consumo`, query.mes, query.tipoConsumoId],
    async () => {
      const { data } = await http.get<ConsumoDto>("/v1/consumo", {
        params: query,
      });

      return data;
    },
    {
      enabled: !!query.mes && !!query.tipoConsumoId,
    }
  );
}
